import { COLOR4, COLOR5, FONT_BOLD_16_18, RADIO_COLOR } from '../../constants';

export const LayoutStyles = {
  fullWidth: {
    width: '100%',
  },
  root: {
    width: '630px',
    height: '24px',
    display: 'flex',
    gap: '12px',
    transform: 'rotate(0deg)',
    opacity: 1,
    alignItems: 'center',
    justifyContent: 'flex-start',
    '@media (max-width:600px)': {
      width: '330px',
      height: '24px',
      gap: '12px',
    },
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '630px',
    // height: 749,
    '@media (max-width:600px)': {
      width: '100%',
      maxWidth: '375px',
      // height: 'auto',
      mt: 7.875,
      gap: 1.5,
      transform: 'rotate(0deg)',
      opacity: 1,
      display: 'flex',
    },
    '@media (max-width:425px)': {
      width: '100%',
      maxWidth: '320px',
    },
    '@media (min-width:600px) and (max-width:700px)': {
      width: '100%',
      maxWidth: '500px',
    },
  },

  mainContainer: {
    justifyContent: 'center',
    padding: '30px 0',
    '@media (max-width:600px)': {
      padding: '0px 30px',
    },
    '@media (max-width:375px)': {
      padding: '0px 15px',
    },
  },

  continue_button: {
    padding: '10px',
    border: `1px solid ${RADIO_COLOR}`,
    width: '90%',
    background: `${RADIO_COLOR} 0% 0% no-repeat padding-box`,
    borderRadius: '25px',
    opacity: 1,
    font: FONT_BOLD_16_18,
    textTransform: 'none',
    color: COLOR4,

    '&:hover': {
      backgroundColor: RADIO_COLOR,
    },
    '&:focus': {
      outline: `2px solid ${RADIO_COLOR}`,
      outlineOffset: '2px',
    },
    '&.Mui-disabled span': {
      opacity: 0.6,
    },

    '@media (max-width:600px)': {
      width: '100%',
      marginBottom: '20px',
    },
  },

  back_button: {
    border: `1px solid ${RADIO_COLOR}`,
    padding: '10px',
    width: '90%',
    borderRadius: '25px',
    opacity: 1,
    margin: '0px 15px 0px 0px',
    font: FONT_BOLD_16_18,
    color: `${RADIO_COLOR} !important`,
    textTransform: 'none',

    '&:hover': {
      backgroundColor: COLOR4,
    },
    '&:focus': {
      outline: `2px solid ${RADIO_COLOR}`,
      outlineOffset: '2px',
    },

    '@media (max-width:600px)': {
      width: '100%',
    },
  },

  btnContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '24px',
    marginTop: '30px',
    width: '100%',
    flexWrap: 'nowrap',
    '@media (max-width:600px)': {
      flexWrap: 'wrap',
      justifyContent: 'center',
    },
  },

  mailingAddressSwitchContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    margin: '20px 0 10px 0',
    minHeight: '25px',
  },
  switchPosition: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    marginTop: '-8px',
  },
  tooltipStyle: {
    display: 'flex',
    alignItems: 'center',
  },
  utilityBillcardcontent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    gap: '18px',
  },
  utilityBillCardText: {
    fontFamily: 'Arial',
    fontStyle: 'normal',
    fontWeight: '700',
    fontSize: '16px',
    lineHeight: 'normal',
    textAlign: 'center',
  },
  utilityLabelSubtext: {
    fontSize: '14px',
    fontWeight: '400',
    // color: '#444444',
  },
  tab: { width: '50%', textTransform: 'none', fontWeight: 700, lineHeight: '20px' },
  customSwitchFunding: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '84px',
    '@media (max-width:600px)': {
      flexDirection: 'column',
      height: '150px',
      padding: '0px 24px',
    },
  },
  customSwitchFundingText: {
    fontWeight: 700,
  },
  verificationPending: {
    display: 'flex',
    justifyContent: 'center',
  },
  verificationPendingContainer: {
    padding: '20px',

    border: '1px solid #F6CE8C',
    borderRadius: '6px',
    width: '100%',
    marginTop: '20px',
  },
  verificationPendingHeading: {
    fontWeight: 700,
  },
  fileUploadName: {
    fontSize: '14px',
    fontWeight: 400,
  },
  fileUploadSize: {
    fontSize: '12px',
    fontWeight: 400,
    color: '#989692',
  },
  fileUploadLink: {
    fontSize: '14px',
    fontWeight: 700,
    textDecoration: 'none',
    color: '#661C69',
  },
  fileInput: {
    position: 'absolute',
    top: 0,
    left: 0,
    height: '100%',
    width: '100%',
    opacity: 0,
    cursor: 'pointer',
  },
  plaidSucessContainer: {
    padding: '20px',
    border: '1px solid rgba(118, 187, 112, 1) !important',
    borderRadius: '6px',
    width: '100%',
    marginTop: '20px',
  },

  fileUploadContainer: {
    padding: '10px',
    borderRadius: '6px',
    width: '100%',
    // marginTop: '20px',
  },
  text: {
    fontFamily: 'Arial',
    fontWeight: 700,
    fontSize: '16px',
    lineHeight: '100%',
  },
  subtext: {
    fontFamily: 'TTNORMSPROBOLD',
    fontWeight: 700,
    fontSize: '16px',
    lineHeight: '100%',
    width: '259px',
    height: '19px',
    whiteSpace: 'nowrap',
  },
  uploadDone: {
    padding: '10px',
    borderRadius: '6px',
    width: '100%',
    '@media (max-width:600px)': {
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'nowrap',
    },
  },
};
